'use client';

import React from 'react';

const RoleOfLeaders = () => {
  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            The Role of AI Change Leaders
          </h2>

          <div className="space-y-8 text-lg text-gray-800 font-body leading-relaxed">
            <p>
              AI Change Leaders exists to define, articulate, and advance the discipline of AI Change Leadership. It is an independent, cross-industry network focused on establishing shared language, defining emerging standards, and leadership capabilities for continuous transformation.
            </p>

            <div className="bg-white border-2 border-gray-200 p-8">
              <h3 className="text-2xl font-bold text-[#0A2540] mb-6">Core Functions</h3>
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <div>
                    <h4 className="font-bold text-[#0A2540] mb-2">Defining the Discipline</h4>
                    <p className="text-gray-700">Establishing clear definitions, principles, and boundaries for AI Change Leadership as a distinct organisational capability.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <div>
                    <h4 className="font-bold text-[#0A2540] mb-2">Articulating Shared Language</h4>
                    <p className="text-gray-700">Developing common terminology and frameworks that enable boards, executive teams, and practitioners to discuss AI-driven change with precision.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <div>
                    <h4 className="font-bold text-[#0A2540] mb-2">Defining Emerging Standards</h4>
                    <p className="text-gray-700">Identifying and codifying practices, governance models, and leadership capabilities that enable successful AI adoption at scale.</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-2 h-2 bg-[#0A2540] mt-2"></div>
                  <div>
                    <h4 className="font-bold text-[#0A2540] mb-2">Informing Leadership Conversations</h4>
                    <p className="text-gray-700">Supporting boards, executive teams, and public leaders in understanding and governing AI-driven transformation responsibly and effectively.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white border-2 border-gray-200 p-8">
              <h3 className="text-2xl font-bold text-[#0A2540] mb-6">Developing the Discipline Collaboratively</h3>
              <p className="mb-4">
                AI Change Leadership is an emerging discipline. Its credibility and durability depend on collective insight, not individual authorship.
              </p>
              <p className="mb-4">
                AI Change Leaders is developing the AI Change Leadership System™ in collaboration with senior leaders from industry and government, trusted advisors, and academic contributors with expertise in organisational change, governance, and technology.
              </p>
              <p>
                This collaborative approach reflects the belief that effective leadership capabilities for AI-driven change must be informed by real-world practice, research, and cross-sector dialogue.
              </p>
            </div>

            <div className="bg-white border-2 border-gray-200 p-8">
              <h3 className="text-2xl font-bold text-[#0A2540] mb-6">Assessment & Recognition</h3>
              <p className="mb-4">
                As organisations navigate AI-driven change, boards and executive teams increasingly face questions that extend beyond technology—questions of leadership readiness, organisational risk, pace of change, and long-term capability.
              </p>
              <p>
                AI Change Leaders assesses organisations against the AI Change Leader Standard, benchmarks their maturity, and recognises those that demonstrate the capability to lead continuous transformation responsibly and effectively. Where appropriate, this perspective may be applied through advisory conversations focused on readiness, alignment, and stewardship.
              </p>
            </div>

            <div className="mt-8 p-8 bg-[#0A2540] text-white">
              <p className="text-xl font-semibold">
                AI Change Leaders does not position itself as a delivery or implementation partner. It exists to provide the intellectual and practical foundation for a discipline that organisations and institutions will build upon.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoleOfLeaders;